const STRUGGLE_TOPIC_PREFIX = "practice text for tricky words";

export function buildStruggleTopicSeed(
  language: string,
  now: Date = new Date(),
): string {
  const normalizedLanguage = (language || "unknown").trim().toLowerCase();
  return `${STRUGGLE_TOPIC_PREFIX} - ${normalizedLanguage} - ${now.toISOString()}`;
}

